module.exports = __webpack_public_path__ + "img/stateMap.062a9d26.png";